import Modal from "@mui/material/Modal";
import { Box } from "@mui/material";
import {
  ButtonWrapper,
  CloseButton,
  CloseButtonWrapper,
  Description,
  ModalWrapper,
  Title,
} from "../style/modalStyle";
import CustomButton from "./CustomButton";
import { CrossIcon } from "../../assets/Icon/ModalIcon";

interface ConfirmModalProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  loading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * A plain confirm / cancel dialog.
 *
 * CustomModal renders instruction lists and has no actions, so anything that
 * needs the user to acknowledge and continue had been hand-rolling a Modal.
 * Built from the same modalStyle primitives so it matches those.
 */
export default function ConfirmModal({
  open,
  title,
  message,
  confirmLabel = "Proceed",
  cancelLabel = "Cancel",
  loading,
  onConfirm,
  onCancel,
}: ConfirmModalProps) {
  return (
    <Modal
      open={open}
      onClose={onCancel}
      aria-labelledby="confirm-modal-title"
      aria-describedby="confirm-modal-description"
    >
      <ModalWrapper sx={{ paddingBottom: "24px" }}>
        <CloseButtonWrapper>
          <CloseButton onClick={onCancel}>
            <CrossIcon />
          </CloseButton>
        </CloseButtonWrapper>

        <Box sx={{ padding: "8px 32px 0" }}>
          <Title id="confirm-modal-title" sx={{ mb: 1.5 }}>
            {title}
          </Title>
          <Description id="confirm-modal-description">{message}</Description>
        </Box>

        {/* ButtonWrapper is display:block unless it is given isTax, so the
            actions stack. Flex here keeps them side by side and right-aligned,
            with the affirmative action last. */}
        <ButtonWrapper
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            gap: "12px",
            mt: 3,
          }}
        >
          <CustomButton
            btnTitle={cancelLabel}
            handleClick={onCancel}
            bgColor="#fff"
            textColor="#2977CC"
            borderColor="#2977CC"
            disabled={loading}
          />
          <CustomButton
            btnTitle={confirmLabel}
            handleClick={onConfirm}
            loading={loading}
          />
        </ButtonWrapper>
      </ModalWrapper>
    </Modal>
  );
}
